import { render } from "./headerAbout.vue?vue&type=template&id=89003b3c&scoped=true"
import script from "./headerAbout.vue?vue&type=script&lang=js"
export * from "./headerAbout.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./headerAbout.vue?vue&type=style&index=1&id=89003b3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89003b3c"]])

export default __exports__